import React, { useState } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';

import { Image } from 'antd';
import classNames from 'classnames';
import styled from 'styled-components';

import ZoomControls from 'common/Widgets/Photos/ZoomControls';

import { usePhotosContext } from './PhotosContext';

const ControlsContainer = styled.div`
  position: absolute;
  z-index: 10;
  bottom: 95px;
  right: 95px;
  display: none;
`;

const Caption = styled.div`
  position: absolute;
  width: 945px;
  z-index: 10;
  bottom: 0;
  text-align: center;
  color: var(--white);
  font-size: 14px;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.55));
  padding: 10px 0px 15px 0px;
`;

const Container = styled.div`
  &:hover ${ControlsContainer} {
    display: flex;
  }

  &.zoomable {
    cursor: grab;
  }
`;

const PhotosPreviewCarousalDisplay = () => {
  const [isZoomed, setIsZoomed] = useState<boolean>(false);

  const { photos, selectedPhotoIndex } = usePhotosContext();
  const imgUrl = photos[selectedPhotoIndex]?.url;
  const caption = photos[selectedPhotoIndex]?.image_category;

  return (
    <Container className={classNames({ zoomable: isZoomed })}>
      <TransformWrapper>
        <ControlsContainer>
          <ZoomControls setIsZoomed={setIsZoomed} />
        </ControlsContainer>
        <TransformComponent>
          <Image
            src={imgUrl}
            alt="img"
            width="945px"
            height="645px"
            style={{ objectFit: 'scale-down' }}
            preview={false}
            fallback={'/no-image.png'}
          />
          <Caption>{caption}</Caption>
        </TransformComponent>
      </TransformWrapper>
    </Container>
  );
};

export default PhotosPreviewCarousalDisplay;
